import { htmlFromString } from '../common/utils'
import ModalBase from './base'

class LoadingModal {

  loadingModalDefaults = {
    allowClose: false,
    clickOutside: false,
    width: '420px'
  };
  open = false;

  constructor(settings) {
    this.settings = {
        ...this.settings,
        ...this.loadingModalDefaults,
        ...settings,
    };
    const contents = htmlFromString(`<div id="loadingModal" class="eviteModalContent"><div class="loadingContainer"><div class="loader">Loading...</div></div></div>`);
    contents.querySelector('.loadingContainer').style.cssText = `
      background: white;
      width: ${this.settings.width};
      height: 233px;
      border: 1px solid #A8A8A8;
      border-radius: 6px;
      overflow: hidden;`;

    this.target = contents;
    return this;
  }

  close = () => {
    if (this.open) {
      this.open = false;
      const modalDom = document.getElementById('loadingModal');
      if (modalDom) {
        // Use this instead of remove for ie11 support
        modalDom.parentNode.removeChild(modalDom);
      }
    }
    return ModalBase.getInstance().close();
  };

  show = (message) => {
    document.querySelector('body').appendChild(this.target);
    let modal = ModalBase.getInstance();
    modal.initialize(this);
    if (message) this.target.querySelector('.loader').innerHTML = message;
    modal.open(`#loadingModal`);
    this.open = true;
  };
}

export default LoadingModal



// WEBPACK FOOTER //
// ./assets/es6/modal/loading_modal.es6